import React, { ChangeEvent } from "react";
import "./HeroText.scss";
import { updateTemplate } from "../../../../apis/updateTemplate";
import { toast } from "react-toastify";

export interface TextProps {
  title: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  handleCloseTitleModal: () => void;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const HeroTitle: React.FC<TextProps> = ({
  title,
  setTitle,
  handleCloseTitleModal,
  loading,
  setLoading,
}) => {
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newNote = event.target.value;
    setTitle(newNote);
  };

  const onUpdateTitle = () => {
    const update = {
      hero_section_title_en: title,
    };
    setLoading(true);
    updateTemplate(update)
      .then((response) => {
        toast.success("Title Updated Successfully");
        handleCloseTitleModal();
        setLoading(false);
      })
      .catch((error) => {
        toast.error("Title Updating Error. Please Try Again.");
      });
  };

  return (
    <div className="edit-text">
      <input
        type="text"
        value={title}
        onChange={handleInputChange}
        className="edit-input"
      />
      <button className="edit-button" onClick={onUpdateTitle}>
        {loading ? "Loading..." : "Update"}
      </button>
    </div>
  );
};

export default HeroTitle;
